<template>
  <!-- lal -->
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">{{ column }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(record, idx) in data" :key="idx">
        <td>
          <ColumnRender
            :format="record.format"
            :value="record.v"
            :task_id="-1"
            :key="idx"
          ></ColumnRender>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import ColumnRender from "@/components/internal/ColumnRender.vue";
export default {
  name: "targetColumnRenderv2",
  components: { ColumnRender },
  data() {
    return {
      parsedValue: this.parser(),
      data: [],
      columns: [{ dataIndex: "v", key: "v", slot: "v" }],
    };
  },
  beforeMount() {
    this.pars(this.column);
  },
  props: ["value", "column", "level"],
  computed: {},
  methods: {
    getCount(key) {
      let total = 0;
      this.parsedValue.forEach((e) => {
        let keys = Object.keys(e);
        if (keys) {
          let key = keys[0];
          if (key.toString().test(key)) total++;
        }
      });
      return total;
    },
    pars(startKey) {
      try {
        let noMore = true; // are there fields with more depth?
        this.parsedValue.forEach((e) => {
          let key = e["field_name"];
          let value = e["value"];

          if (key.startsWith(startKey)) {
            if (key === startKey) {
              // 0 level records
              // to do...
              this.data.push({
                v: `${value}`,
                format: startKey.includes(":image") ? "image" : "text",
              });
            } else {
              this.data.push({
                format: startKey.includes(":image") ? "image" : "text",
                v: `${key.toString().split(".").slice(1).join("")}: ${value}`,
              });
            }
          }
          //}
        });
      } catch (e) {}
    },
    parser() {
      try {
        return JSON.parse(this.value);
      } catch (e) {
        return {};
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/internal/TargetColumnRenderV2.vue